import { FC, ReactNode } from "react";

import { Button } from "@/components/atoms/buttons/Button";
// import OutlineButton from "@/components/atoms/buttons/OutlineButton";
import { IsDefault, IsMobile } from "@/components/atoms/mediaQuery/MediaQuery";

// import ChevronIcon from "/public/icon/chevron-right.svg";

interface Props {
  onClickBack: () => Promise<void>;
  onClickDraftButton: () => Promise<void>;
  onClickCreateButton: () => Promise<void>;
  onClickCreatePrivateButton?: () => void;
}

export const PageEditFooter: FC<Props> = ({
  onClickBack,
  onClickDraftButton,
  onClickCreateButton,
  onClickCreatePrivateButton,
}) => {
  const wrap = (children: ReactNode) => (
    <footer className="fixed bottom-0 left-0 z-[10] px-6 py-2 w-full bg-[#4C4C4C]">
      {children}
    </footer>
  );

  return wrap(
    <>
      <IsDefault>
        <ul className="flex gap-[10px] justify-end items-center w-full">
          <li>
            <Button
              type="button"
              label="一時保存（非公開）"
              size="sm"
              color="primary-outline"
              className="!min-w-[160px] !w-auto !bg-white"
              onClick={onClickDraftButton}
            />
          </li>
          <li>
            <Button
              type="button"
              label="公開"
              size="sm"
              color="primary"
              className="w-40"
              onClick={onClickCreateButton}
            />
          </li>
        </ul>
      </IsDefault>
      <IsMobile>
        {/* <ul className="flex justify-between items-center">
          <li>
            <button
              type="button"
              className="flex items-center p-2 space-x-0.5 text-white"
              onClick={() => void onClickBack()}
            >
              <ChevronIcon
                width={24}
                height={24}
                className="-scale-x-90 fill-white"
              />
              <span className="whitespace-nowrap">編集終了</span>
            </button>
          </li>
          <li>
            <OutlineButton color="white" onClick={onClickDraftButton}>
              保存
            </OutlineButton>
          </li>
          <li>
            <Button
              label="非公開"
              color={"delete"}
              onClick={onClickCreatePrivateButton}
            />
          </li>
          <li>
            <Button label="公開" onClick={onClickCreateButton} />
          </li>
        </ul> */}
        <div className="flex gap-x-2 items-center justify-center">
          <Button
            type="button"
            label="一時保存（非公開）"
            size="sm"
            color="primary-outline"
            className="w-40 !bg-white text-sm"
            onClick={onClickDraftButton}
          />
          <Button
            type="submit"
            label="公開"
            size="sm"
            color="primary"
            className="w-40 text-sm"
            onClick={onClickCreateButton}
          />
        </div>
      </IsMobile>
    </>,
  );
};
